import { useQuery } from '@tanstack/react-query'

import { type AdditionalParticipants } from 'components/member_onboarding_v2/types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export function useGetMemberOnboardingAdditionalParticipants ({
  enrollmentEventId,
}: {
  enrollmentEventId: string;
}) {
  return useQuery<AdditionalParticipants, GrapeAPIErrorType>({
    queryKey: ['enrollmentEvent', enrollmentEventId, 'additional_participants'],
    queryFn: async () => {
      const response = await fetchWithHeaders(
        `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants`
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
          requestId: response.headers.get('x-request-id') ?? undefined
        })
      }
      return response.json()
    },
    retry: false,
  })
}
